import { __extends } from "tslib";
import { PlaneClassification } from '@awayjs/core';
import { BoundingVolumeBase } from '../bounds/BoundingVolumeBase';
var NullBounds = /** @class */ (function (_super) {
    __extends(NullBounds, _super);
    function NullBounds() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //@override
    NullBounds.prototype.isInFrustum = function (planes, numPlanes) {
        return true;
    };
    NullBounds.prototype.classifyToPlane = function (plane) {
        return PlaneClassification.INTERSECT;
    };
    return NullBounds;
}(BoundingVolumeBase));
export { NullBounds };
